import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faGitlab, faJenkins } from "@fortawesome/free-brands-svg-icons"
import { useHelpDeskReport } from "../../Hooks/Features/ServiceReports/useHelpDeskReport"
import CommonGrid from "../CommonCompo/CommonGrid/CommonGrid";
import { useTheme } from "../../context/ThemeContext";

const HelpDeskReport = ({ filterValues, setFilterValues }) => {

    const { theme } = useTheme();
    const { status, setStatus, columns, rowData, loader } = useHelpDeskReport({ filterValues, setFilterValues });

    return (
        <div>
            <div className={`tab-menu mx-2 ${theme === "dark" ? "dark" : ""}`}>
                <div className={`tab-menu-item ${status === "active" ? `active${theme === "dark" ? "-dark" : ""}` : ""}`} onClick={() => { setStatus("active"); setFilterValues((prev) => ({ ...prev, apiCall: true })); }}>Active Access</div>
                <div className={`tab-menu-item ${status === "expired" ? `active${theme === "dark" ? "-dark" : ""}` : ""}`} onClick={() => { setStatus("expired"); setFilterValues((prev) => ({ ...prev, apiCall: true })); }}>Expired Rights</div>
            </div>
            <div className="mt-2 mx-2" style={{ height: "calc(100vh - 170px)", overflow: "auto" }}>
                <CommonGrid columns={columns} data={[{ id: "all", title: "", children: rowData?.[filterValues?.type] }]} rowHeight={30} loader={loader?.[filterValues?.type]} fixedWidth={true} />
            </div>
        </div>
    )
}

export default HelpDeskReport